import envVar from '../config/envVars';
import { UpsertAcademicYearDatesBody } from '../types/academicYearType';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';

const getAcademicYears = async (school: string) => {
  return httpGet(
    `${envVar.REACT_APP_BASE_API_URL}/schools/${school}/academic-year-dates`
  );
};

const getAcademicYearByGrade = async (school: string, grade: string) => {
  return httpGet(
    `${envVar.REACT_APP_BASE_API_URL}/schools/${school}/academic-year-dates?grade=${grade}`
  );
};

const upsertAcademicYears = async (
  school: string,
  payload: UpsertAcademicYearDatesBody
) => {
  return httpPost(
    `${envVar.REACT_APP_BASE_API_URL}/schools/${school}/academic-year-dates`,
    payload
  );
};

const academicYears = {
  getAcademicYears,
  getAcademicYearByGrade,
  upsertAcademicYears
};

export default academicYears;
